<section class="access-denied-wrapper">
  <div class="ad-container text-center">
    <img src="assets/images/access-denied.png" alt="">
    <a href="/" class="btn btn-dark mt-3 waves-effect waves-yellow text-center">
      <i class="dripicons-home"></i> Go Back Home
    </a>
  </div>
</section>
